import React from 'react';
import Icon from '../../../components/AppIcon';
import Image from '../../../components/AppImage';

const BenefitsPanel = () => {
  const benefits = [
  {
    icon: 'DollarSign',
    title: 'Prix transparents',
    description: 'Prix affiché — pas de frais cachés. Toute variation est d\'abord expliquée et validée'
  },
  {
    icon: 'MapPin',
    title: 'Suivi en temps réel',
    description: 'Suivez votre technicien en direct avec ETA précis et notifications automatiques'
  },
  {
    icon: 'Clock',
    title: 'Intervention rapide',
    description: 'Créneaux disponibles sous 1h, aujourd\'hui ou demain selon votre urgence'
  },
  {
    icon: 'FileText',
    title: 'Devis gratuit',
    description: 'Sur devis : diagnostic rapide, devis net avant toute action'
  },
  {
    icon: 'Shield',
    title: 'Garantie 6 mois',
    description: 'Toutes nos interventions sont garanties avec SAV dédié'
  },
  {
    icon: 'Star',
    title: 'Techniciens certifiés',
    description: 'Professionnels qualifiés avec checklists qualité et formation continue'
  }];


  const testimonials = [
  {
    name: 'Marie Dubois',
    role: 'Cliente particulière',
    avatar: "https://img.rocket.new/generatedImages/rocket_gen_img_1671565f5-1763295143368.png",
    avatarAlt: 'Portrait professionnel d\'une femme française souriante aux cheveux bruns courts portant un chemisier blanc',
    rating: 5,
    comment: 'Service impeccable ! Le prix annoncé était respecté et le technicien très professionnel.'
  },
  {
    name: 'Jean Martin',
    role: 'Gérant de restaurant',
    avatar: "https://img.rocket.new/generatedImages/rocket_gen_img_1f485cebb-1766776066694.png",
    avatarAlt: 'Portrait professionnel d\'un homme français en costume gris avec cravate bleue et lunettes',
    rating: 5,
    comment: 'Intervention d\'urgence résolue en 2h. Le suivi en temps réel est vraiment pratique.'
  }];


  return (
    <div className="space-y-6">
      <div className="bg-card rounded-lg shadow-md p-6">
        <h3 className="text-lg font-semibold text-foreground mb-6">
          Pourquoi choisir PlumberPro ?
        </h3>
        
        <div className="space-y-4">
          {benefits?.map((benefit, index) =>
          <div key={index} className="flex items-start gap-3">
              <div className="w-10 h-10 bg-primary/10 rounded-lg flex items-center justify-center flex-shrink-0">
                <Icon name={benefit?.icon} size={20} color="var(--color-primary)" />
              </div>
              <div>
                <h4 className="text-sm font-medium text-foreground mb-1">
                  {benefit?.title}
                </h4>
                <p className="text-xs text-muted-foreground">
                  {benefit?.description}
                </p>
              </div>
            </div>
          )}
        </div>
      </div>
      <div className="bg-card rounded-lg shadow-md p-6">
        <h3 className="text-lg font-semibold text-foreground mb-4">
          Témoignages clients
        </h3>
        
        <div className="space-y-4">
          {testimonials?.map((testimonial, index) =>
          <div key={index} className="bg-muted rounded-lg p-4">
              <div className="flex items-center gap-3 mb-3">
                <div className="w-12 h-12 rounded-full overflow-hidden flex-shrink-0">
                  <Image
                  src={testimonial?.avatar}
                  alt={testimonial?.avatarAlt}
                  className="w-full h-full object-cover" />

                </div>
                <div className="flex-1">
                  <h4 className="text-sm font-medium text-foreground">
                    {testimonial?.name}
                  </h4>
                  <p className="text-xs text-muted-foreground">
                    {testimonial?.role}
                  </p>
                </div>
                <div className="flex gap-0.5">
                  {[...Array(testimonial?.rating)]?.map((_, i) =>
                <Icon key={i} name="Star" size={14} color="var(--color-warning)" />
                )}
                </div>
              </div>
              <p className="text-sm text-foreground">
                "{testimonial?.comment}"
              </p>
            </div>
          )}
        </div>
      </div>
      <div className="bg-gradient-to-br from-primary/10 to-accent/10 rounded-lg p-6 border border-primary/20">
        <div className="flex items-start gap-3">
          <div className="w-12 h-12 bg-primary rounded-lg flex items-center justify-center flex-shrink-0">
            <Icon name="Zap" size={24} color="#FFFFFF" />
          </div>
          <div>
            <h4 className="text-sm font-semibold text-foreground mb-2">
              Nouveau client ?
            </h4>
            <p className="text-xs text-muted-foreground mb-3">
              Créez un compte pour bénéficier de l'historique de vos services, de la gestion de vos documents et de réservations plus rapides.
            </p>
            <div className="flex flex-wrap gap-2">
              <span className="px-2 py-1 bg-success/10 text-success text-xs font-medium rounded">
                -10% première intervention
              </span>
              <span className="px-2 py-1 bg-primary/10 text-primary text-xs font-medium rounded">
                Garantie étendue
              </span>
            </div>
          </div>
        </div>
      </div>
    </div>);

};

export default BenefitsPanel;